module.exports = __webpack_public_path__ + "img/160.3f727bdf.png";